import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-prompt', {
    attrs: {
      "color": "danger",
      "title": _vm.$i18n_t('Common.questionDeleteItem'),
      "open": _vm.cascadePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        color: 'danger',
        emit: 'delete'
      }]
    },
    on: {
      "close": function ($event) {
        _vm.cascadePrompt = false;
      },
      "cancel": function ($event) {
        _vm.cascadePrompt = false;
      },
      "delete": function ($event) {
        return _vm.confirmCascadeDelete();
      }
    }
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Connectors.cascadePrompt.usedByTitle')))]), _c('ul', {
    staticStyle: {
      "padding-left": "18px",
      "margin": "0"
    }
  }, _vm._l(_vm.cascadeFlows, function (flow) {
    return _c('li', {
      key: flow.id,
      staticStyle: {
        "margin-bottom": "4px"
      }
    }, [_c('router-link', {
      attrs: {
        "to": `/connectors/consumers/list?openFlowId=${flow.id}`
      }
    }, [_vm._v("\n            " + _vm._s(flow.name) + " (#" + _vm._s(flow.id) + ")\n          ")])], 1);
  }), 0), _c('div', {
    staticClass: "mt-2"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Connectors.cascadePrompt.deleteAllConfirm')))])]), _c('core-prompt', {
    attrs: {
      "color": "danger",
      "title": _vm.$i18n_t('Common.areYouSure'),
      "open": _vm.deletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('Common.delete'),
        color: 'danger',
        emit: 'delete'
      }]
    },
    on: {
      "close": function ($event) {
        _vm.deletePrompt = false;
      },
      "cancel": function ($event) {
        _vm.deletePrompt = false;
      },
      "delete": function ($event) {
        return _vm.deleteFilter(_vm.deleteItemId);
      }
    }
  }, [_vm._v("\n      " + _vm._s((_vm.filters.find(t => t.id === _vm.deleteItemId) || {}).name) + "\n    ")]), _c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.formDialogOpen,
      "max-width": "900",
      "persistent": ""
    },
    on: {
      "close": _vm.closeDialog
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_c(VRow, {
          staticStyle: {
            "flex-wrap": "nowrap",
            "width": "100%"
          },
          attrs: {
            "no-gutters": ""
          }
        }, [_c(VCol, {
          staticClass: "flex-grow-1 flex-shrink-0"
        }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Connectors.Filter.editDialog.title')) + "\n          ")]), _c(VCol, {
          staticClass: "flex-grow-0 flex-shrink-1",
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c(VSwitch, {
          staticClass: "mt-0",
          attrs: {
            "hide-details": "",
            "color": _vm.color,
            "label": "Extended mode",
            "data-cy": "filterExtended",
            "disabled": !_vm.canManageIntegrations
          },
          on: {
            "change": _vm.switchExtended
          },
          model: {
            value: _vm.filterExtended,
            callback: function ($$v) {
              _vm.filterExtended = $$v;
            },
            expression: "filterExtended"
          }
        })], 1)], 1)];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_vm.canManageIntegrations ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "disabled": !_vm.formValid,
            "prepend-icon": "fa-plus",
            "data-cy": "saveFilterButton"
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v("\n          " + _vm._s(_vm.filterModel.id ? _vm.$i18n_t('Common.save') : _vm.$i18n_t('Common.create')) + "\n        ")]) : _vm._e()];
      },
      proxy: true
    }])
  }, [_c(VContainer, {
    staticClass: "pa-0 filters",
    attrs: {
      "fluid": ""
    }
  }, [_c(VForm, {
    ref: "form",
    attrs: {
      "readonly": !_vm.canManageIntegrations
    },
    model: {
      value: _vm.formValid,
      callback: function ($$v) {
        _vm.formValid = $$v;
      },
      expression: "formValid"
    }
  }, [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VTextField, {
    staticClass: "required",
    attrs: {
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.requiredRule,
      "label": _vm.$i18n_t('Connectors.Filter.editDialog.name'),
      "hide-details": "auto",
      "data-cy": "filterName"
    },
    model: {
      value: _vm.filterModel.name,
      callback: function ($$v) {
        _vm.$set(_vm.filterModel, "name", $$v);
      },
      expression: "filterModel.name"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "label": _vm.$i18n_t('accMgmt.system.tenantSelector'),
      "items": _vm.accounts,
      "color": _vm.color,
      "disabled": !_vm.isCreateDialog,
      "outlined": _vm.inpOutlined,
      "rules": _vm.requiredRule,
      "filled": _vm.inpFilled,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "data-cy": "filterAccount"
    },
    model: {
      value: _vm.selectedAccount,
      callback: function ($$v) {
        _vm.selectedAccount = $$v;
      },
      expression: "selectedAccount"
    }
  })], 1), _vm.filterExtended ? _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "items": _vm.filterTypes,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.requiredRule,
      "label": _vm.$i18n_t('Connectors.Filter.editDialog.type'),
      "menu-props": {
        offsetY: true
      },
      "hide-details": "auto",
      "data-cy": "filterExtendedType"
    },
    model: {
      value: _vm.filterModel.filter.type,
      callback: function ($$v) {
        _vm.$set(_vm.filterModel.filter, "type", $$v);
      },
      expression: "filterModel.filter.type"
    }
  })], 1) : _vm._e(), _vm.filterExtended ? _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VAutocomplete, {
    staticClass: "required",
    attrs: {
      "items": _vm.inputTypes,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "rules": _vm.requiredRule,
      "label": _vm.$i18n_t('Connectors.Filter.editDialog.inputType'),
      "menu-props": {
        offsetY: true
      },
      "hide-details": "auto",
      "data-cy": "filterExtendedInputType"
    },
    model: {
      value: _vm.filterModel.filter.inputType,
      callback: function ($$v) {
        _vm.$set(_vm.filterModel.filter, "inputType", $$v);
      },
      expression: "filterModel.filter.inputType"
    }
  }), _c('p', {
    staticClass: "card-description mt-2"
  }, [_c('code', [_vm._v("application/json")]), _vm._v("\n                " + _vm._s(_vm.$i18n_t('Connectors.Filter.editDialog.inputTypeDescription1').toUpperCase()) + "\n                "), _c('code', [_vm._v("text/plain")]), _vm._v("\n                . " + _vm._s(_vm.$i18n_t('Connectors.Filter.editDialog.inputTypeDescription2').toUpperCase()) + "\n                "), _c('code', [_vm._v("generic")]), _vm._v("\n                .\n              ")])], 1) : _vm._e()], 1), !_vm.filterExtended ? _vm._l(_vm.filterRows, function (filterItem, idx) {
    return _c(VRow, {
      key: idx,
      class: {
        'mb-4': idx === _vm.filterRows.length - 1
      },
      staticStyle: {
        "min-width": "0"
      }
    }, [_c(VCol, {
      attrs: {
        "cols": "4"
      }
    }, [_c(VCombobox, {
      attrs: {
        "items": _vm.attributesSelect,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('Consumers.Filter.createDialog.attribute'),
        "hide-details": "auto",
        "rules": _vm.requiredRule,
        "menu-props": {
          offsetY: true
        },
        "data-cy": `filterMultiAttribute_${idx}`
      },
      model: {
        value: filterItem.attribute,
        callback: function ($$v) {
          _vm.$set(filterItem, "attribute", $$v);
        },
        expression: "filterItem.attribute"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "3"
      }
    }, [_c(VCombobox, {
      attrs: {
        "items": _vm.operatorSelect,
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('Consumers.Filter.createDialog.operator'),
        "hide-details": "auto",
        "rules": _vm.requiredRule,
        "menu-props": {
          offsetY: true
        },
        "data-cy": `filterMultiOperator_${idx}`
      },
      on: {
        "change": function ($event) {
          filterItem.operator === 'IS_NULL' || filterItem.operator === 'IS_NOT_NULL' ? filterItem.values = null : filterItem.values;
        }
      },
      model: {
        value: filterItem.operator,
        callback: function ($$v) {
          _vm.$set(filterItem, "operator", $$v);
        },
        expression: "filterItem.operator"
      }
    })], 1), _c(VCol, {
      attrs: {
        "cols": "5"
      }
    }, [filterItem.operator !== 'IS_NULL' && filterItem.operator !== 'IS_NOT_NULL' ? _c(VCombobox, {
      attrs: {
        "color": _vm.color,
        "outlined": _vm.inpOutlined,
        "filled": _vm.inpFilled,
        "label": _vm.$i18n_t('Consumers.Filter.createDialog.values'),
        "append-icon": "",
        "multiple": "",
        "deletable-chips": "",
        "delimiters": [','],
        "small-chips": "",
        "hide-details": "auto",
        "data-cy": `filterMultiValues_${idx}`,
        "rules": [v => v.length > 0 || _vm.$i18n_t('Common.fieldRequired')]
      },
      scopedSlots: _vm._u([{
        key: "selection",
        fn: function ({
          attrs,
          item
        }) {
          return [_c(VChip, _vm._b({
            attrs: {
              "close": _vm.canManageIntegrations,
              "data-cy": `filterMultiValuesChip_${idx}_${item}`
            },
            on: {
              "click:close": function ($event) {
                return filterItem.values.splice(_vm.index, 1);
              }
            }
          }, 'v-chip', attrs, false), [_vm._v("\n                      " + _vm._s(item) + "\n                    ")])];
        }
      }, _vm.canManageIntegrations ? {
        key: "append-outer",
        fn: function () {
          return [_c('core-button', {
            staticClass: "mt-0",
            attrs: {
              "title": "Remove",
              "color": _vm.color,
              "prepend-icon": "fa-minus",
              "disabled": _vm.filterRows.length === 1,
              "data-cy": `filterMultiRemoveButton_${idx}`
            },
            on: {
              "click": function ($event) {
                return _vm.removeFilterRow(idx);
              }
            }
          }), _vm._v("\n                     \n                    "), _c('core-button', {
            staticClass: "mt-0",
            attrs: {
              "title": "Add more",
              "color": _vm.color,
              "prepend-icon": "fa-plus",
              "data-cy": `filterMultiAddButton_${idx}`
            },
            on: {
              "click": function ($event) {
                return _vm.addFilterRow(idx);
              }
            }
          })];
        },
        proxy: true
      } : null], null, true),
      model: {
        value: filterItem.values,
        callback: function ($$v) {
          _vm.$set(filterItem, "values", $$v);
        },
        expression: "filterItem.values"
      }
    }) : _vm.canManageIntegrations ? _c('div', {
      staticStyle: {
        "text-align": "right",
        "margin-top": "8px",
        "margin-right": "-3px"
      }
    }, [_c('core-button', {
      staticClass: "ma-0",
      staticStyle: {
        "margin-right": "2px !important"
      },
      attrs: {
        "title": "Remove",
        "color": _vm.color,
        "prepend-icon": "fa-minus",
        "disabled": _vm.filterRows.length === 1,
        "data-cy": `filterMultiRemoveButton_${idx}`
      },
      on: {
        "click": function ($event) {
          return _vm.removeFilterRow(idx);
        }
      }
    }), _c('core-button', {
      staticClass: "ma-0",
      attrs: {
        "title": "Add more",
        "color": _vm.color,
        "prepend-icon": "fa-plus",
        "data-cy": `filterMultiAddButton_${idx}`
      },
      on: {
        "click": function ($event) {
          return _vm.addFilterRow(idx);
        }
      }
    })], 1) : _vm._e()], 1)], 1);
  }) : _vm._e(), _vm.filterExtended ? [_c(VRow, {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description"
  }, [_vm._v("\n                  CONTAINS  \n                  "), _c('code', [_vm._v("{\"meta\": {...}, \"value\": ...}")]), _vm._v("\n                  , THE ACTUAL ORIGINAL INPUT-VALUE IS ACCESSIBLE VIA  \n                  "), _c('code', [_vm._v("$.value")])]), _c(VExpansionPanels, {
    staticClass: "my-4",
    attrs: {
      "value": null
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Filter.metaValuePanel.title')))])]), _c(VExpansionPanelContent, [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('Connectors.Filter.metaValuePanel.description').toUpperCase()) + "\n                      "), _c('ul', [_c('li', [_c('code', [_vm._v("config_id*")])]), _c('li', [_c('code', [_vm._v("state_id")])]), _c('li', [_c('code', [_vm._v("dtwin_id")])]), _c('li', [_c('code', [_vm._v("dtwin_title")])]), _c('li', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('Connectors.Filter.metaValuePanel.twinCategory'))
    }
  })]), _c('li', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('Connectors.Filter.metaValuePanel.vdeviceGroups'))
    }
  })]), _c('li', [_c('code', [_vm._v("twin_tags")])]), _c('li', [_c('code', [_vm._v("twin_ancestor_ids")])]), _c('li', [_c('code', [_vm._v("twin_key_value")])]), _c('li', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$i18n_t('Connectors.Filter.metaValuePanel.geoLocation'))
    }
  })]), _c('li', [_c('code', [_vm._v("unit")])]), _c('li', [_c('code', [_vm._v("state_identifier")])]), _c('li', [_c('code', [_vm._v("state_type")])]), _c('li', [_c('code', [_vm._v("source_type")])]), _c('li', [_c('code', [_vm._v("parser_variable")])]), _c('li', [_c('code', [_vm._v("source_identifier")])]), _c('li', [_c('code', [_vm._v("timestamp*")])])])])], 1), _c(VExpansionPanel, [_c(VExpansionPanelHeader, [_c('div', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Filter.jsonata.title')))])]), _c(VExpansionPanelContent, [_c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("\n  $.meta.dtwin_id in [123,124,125,126] and $.meta.state_identifier = \"kWh\"\n")]), _c('br'), _c('custom-code', {
    attrs: {
      "block": ""
    }
  }, [_vm._v("\n  \"tag1\" in $.meta.twin_tags and $.meta.state_id in [123,124]\n")])], 1)], 1)], 1), _vm.filterModel.filter.type === 'jsonata' ? [_c('codemirror', {
    ref: "codemirror",
    staticClass: "elevation-3",
    attrs: {
      "options": {
        ..._vm.cmOptions,
        readOnly: !_vm.canManageIntegrations
      },
      "data-cy": "filterExtendedJSONataCode"
    },
    on: {
      "focus": _vm.onCmFocus
    },
    model: {
      value: _vm.filterModel.filter.definition,
      callback: function ($$v) {
        _vm.$set(_vm.filterModel.filter, "definition", $$v);
      },
      expression: "filterModel.filter.definition"
    }
  })] : _vm.filterModel.filter.type === 'javascript' ? [_c('code', [_vm._v("module.exports = (x) => {")]), _c('codemirror', {
    ref: "codemirror",
    staticClass: "elevation-3",
    attrs: {
      "options": {
        ..._vm.cmOptions,
        readOnly: !_vm.canManageIntegrations
      },
      "data-cy": "filterExtendedJavascriptCode"
    },
    on: {
      "focus": _vm.onCmFocus
    },
    model: {
      value: _vm.filterModel.filter.definition,
      callback: function ($$v) {
        _vm.$set(_vm.filterModel.filter, "definition", $$v);
      },
      expression: "filterModel.filter.definition"
    }
  }), _c('code', [_vm._v("}")])] : _vm._e(), _c(VInput, {
    attrs: {
      "value": _vm.filterModel.filter.definition,
      "rules": [v => !!v]
    }
  })], 2)], 1)] : _vm._e()], 2)], 1)], 1), _c('core-header', {
    attrs: {
      "headline": `${_vm.$i18n_t('Bridges.Consumers.drawer.filters')}`,
      "subtitle": `${_vm.$i18n_t('Bridges.Consumers.drawer.filtersDescription')}`
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-account-filter', {
          attrs: {
            "multiple": ""
          },
          on: {
            "change": accounts => {
              _vm.selectedAccounts = accounts;
            },
            "accounts-loaded": function ($event) {
              _vm.loadingAccounts = false;
            }
          }
        }), _vm.isMobile ? [_vm.canManageIntegrations ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-plus",
            "data-cy": "createFilterButton"
          },
          on: {
            "click": function ($event) {
              return _vm.openEditModal();
            }
          }
        }) : _vm._e()] : [_vm.canManageIntegrations ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-plus",
            "data-cy": "createFilterButton"
          },
          on: {
            "click": function ($event) {
              return _vm.openEditModal();
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.create')) + "\n          ")]) : _vm._e()]];
      },
      proxy: true
    }])
  }), !_vm.loadingAccounts ? _c('div', {
    staticClass: "n20-mainrow pt-4"
  }, [_c('core-n20Card', [!_vm.loadingAccounts && !_vm.isLoading && _vm.filters.length === 0 ? _c('core-empty-state', {
    attrs: {
      "icon": "fas fa-filter",
      "color": _vm.color
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Connectors.Filter.emptyState.title')) + "\n          ")];
      },
      proxy: true
    }, {
      key: "button",
      fn: function () {
        return [_vm.canManageIntegrations ? _c('core-button', {
          staticClass: "mt-4",
          attrs: {
            "color": _vm.color,
            "append-icon": "fa-arrow-right"
          },
          on: {
            "click": function ($event) {
              return _vm.openEditModal();
            }
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Connectors.Filter.emptyState.button')) + "\n            ")]) : _vm._e()];
      },
      proxy: true
    }], null, false, 3088192109)
  }, [_c('p', [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Connectors.Filter.emptyState.description')) + "\n          ")])]) : [_c(VTextField, {
    attrs: {
      "color": _vm.color,
      "label": _vm.$i18n_t('Common.search'),
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "append-icon": "fal fa-search",
      "hide-details": "auto",
      "single-line": "",
      "clearable": "",
      "data-cy": "filterSearch"
    },
    on: {
      "click:clear": function ($event) {
        _vm.searchItem = '';
      }
    },
    model: {
      value: _vm.searchItem,
      callback: function ($$v) {
        _vm.searchItem = $$v;
      },
      expression: "searchItem"
    }
  }), _c(VDataTable, {
    attrs: {
      "search": _vm.searchItem,
      "items": _vm.filters,
      "loading": _vm.isLoading,
      "options": _vm.tableOptions,
      "headers": _vm.tableLocalizations.headers,
      "footer-props": _vm.tableLocalizations.footerProps,
      "item-key": "id"
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item.createdAt",
      fn: function ({
        item
      }) {
        return [_vm._v("\n              " + _vm._s(_vm.localizeDate(item.createdAt)) + "\n            ")];
      }
    }, {
      key: "item.tenantId",
      fn: function ({
        item
      }) {
        return [_vm._v("\n              " + _vm._s((_vm.accounts.find(account => account.id === item.tenantId) || {}).name) + "\n            ")];
      }
    }, {
      key: "item.actions",
      fn: function ({
        item
      }) {
        return [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.viewDetails'),
            "small": "",
            "data-cy": "filterEdit"
          },
          on: {
            "click": function ($event) {
              return _vm.openEditModal(item);
            }
          }
        }, [_vm._v("\n                fal " + _vm._s(_vm.canManageIntegrations ? 'fa-edit' : 'fa-eye') + "\n              ")]), _vm._v("\n               \n              "), _vm.canManageIntegrations ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDelete'),
            "small": "",
            "data-cy": "filterRemove"
          },
          on: {
            "click": function ($event) {
              return _vm.showDeletePrompt(item.id);
            }
          }
        }, [_vm._v("\n                fal fa-trash-alt\n              ")]) : _vm._e()];
      }
    }], null, false, 4047764501)
  })]], 2), _c('br'), _c('br')], 1) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };